<style lang="less">
.app-main {
  .app-container {
    .el-pagination {
      text-align: right;
      &.is-background .el-pager li:not(.disabled).active {
        background-color: #005baa;
      }
    }
  }
}
</style>

<template>
  <div class="app-main-container">
    <div class="cate-nav-container container-fixed" v-if="isShowCates">
      <CateNav />
    </div>
    <div class="hairline"></div>
    <div class="bread-crumb-container">
      <Breadcrumb />
    </div>
    <section class="app-main">
      <div class="app-container">
        <transition name="fade-transform" mode="out-in">
          <router-view ref="rv" :key="key" />
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import CateNav from './CateNav'
export default {
  name: 'AppMain',
  components: {
    Breadcrumb,
    CateNav
  },
  props: {
    isShowCates: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      key: this.$router.currentRoute.fullPath
    }
  }
}
</script>


